module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cf_stills_pet_2,25_cepita_fresh_nar.46fa7fe8.png";